function getByteLength(s, b, i, c) {
    if(!s) return 0;
    for (b = i = 0; c = s.charCodeAt(i++); b += c >> 11 ? 3 : c >> 7 ? 2 : 1) ;
    return b;
};

export default getByteLength;
